import { NgModule, DoBootstrap, ErrorHandler } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateFormatPipe, HistoricTypePipe } from './core/pipes';
import { DESIGN_SYSTEM_COMPONENTS } from './design-system/design-system.components';
import { MIGRATED_COMPONENTS } from './migrated-components';
import { GlobalErrorHandler } from './core/error-handler';

const I18N_PREFIX = '/assets/i18n/';
const I18N_SUFFIX = '.json';
const DEFAULT_LANGUAGE = 'pt-BR';

export function httpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, I18N_PREFIX, I18N_SUFFIX);
}

@NgModule({
  declarations: [...DESIGN_SYSTEM_COMPONENTS, ...MIGRATED_COMPONENTS],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    UpgradeModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: DEFAULT_LANGUAGE,
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DateFormatPipe,
    HistoricTypePipe,
  ],
  providers: [
    // VehicleService usa providedIn: 'root', não precisa estar aqui
    // $injector será fornecido pelo UpgradeModule após bootstrap
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
})
export class AppModule implements DoBootstrap {
  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngDoBootstrap() {
    // Bootstrap manual via main.ts
  }
}
